import PropTypes from 'prop-types'
import React from 'react'
import { findDOMNode } from 'react-dom'
import {
  MenuItem
} from 'components/Menu'
import {
  ModalMenu
} from 'components/Modal'
import Avatar from '../Avatar'
import AvatarLoader from '../Avatar/AvatarLoader'
import DraggableUser from '../DraggableUser'
import classes from './AvatarUser.module.scss'

export class AvatarUser extends React.Component {
  static propTypes = {
    size: PropTypes.number,
    active: PropTypes.bool,
    className: PropTypes.string,
    style: PropTypes.object,

    draggable: PropTypes.bool,
    menu: PropTypes.array,
    presence: PropTypes.number,
    onClick: PropTypes.func,

    // User props
    id: PropTypes.number,
    email: PropTypes.string,
    name: PropTypes.string,
    profileKey: PropTypes.string,
    licenseType: PropTypes.number,
    isActive: PropTypes.bool,
    isLoading: PropTypes.bool,
    isLoaded: PropTypes.bool,
    profile: PropTypes.object,
  }

  static defaultProps = {
    size: 40,
  }

  renderAvatar = (props) => {
    const {
      connectDragSource,

      size,
      active,

      className,
      style,
      draggable,
      menu,
      presence,
      onClick,

      name,
      profileKey,
      isActive
    } = props

    let compClassName = ''
    if (menu || draggable || onClick) compClassName += ' ' + classes.hover
    if (className) compClassName += ' ' + className

    return (
      <Avatar
        ref={ref => {
          connectDragSource && connectDragSource(findDOMNode(ref))
        }}
        profileKey={profileKey}
        isActive={isActive}
        name={name}
        size={size}
        active={active}
        presence={presence}
        className={compClassName}
        style={style}
        onClick={onClick}
      />
    )
  }

  renderDraggableAvatar = () => {
    if (this.props.draggable) {
      return (
        <DraggableUser
          {...this.props}
        >
          {this.renderAvatar}
        </DraggableUser>
      )
    } else {
      return this.renderAvatar(this.props)
    }
  }

  render () {
    const {
      size,

      menu,
      className,
      style,

      name,
      isLoaded,
    } = this.props

    return isLoaded ? (
      menu ? (
        <ModalMenu>
          {this.renderDraggableAvatar()}
          <MenuItem
            header
          >
            {name}
          </MenuItem>
          {menu.map((menuItem, index) => {
            const { title, ...menuItemProps } = menuItem

            return (
              <MenuItem
                {...menuItemProps}
                key={index}
              >
                {title}
              </MenuItem>
            )
          })}
        </ModalMenu>
      ) : (
        this.renderDraggableAvatar()
      )
    ) : (
      <AvatarLoader
        size={size}
        className={className}
        style={style}
      />
    )
  }
}

export default AvatarUser
